import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import * as ShipConstants from '../../../Global/Constants';
import { numericValidationWithDot} from '../../../Utils/CommonFunctions';

const textField = (props) => {
	let value = props.value;
	let filterObject = props.filterObject;
	// console.log(filterObject);
	let classname = props.classname ? "form-control "+props.classname : "form-control";
	return (
		<Wrp>
		{
	        ShipConstants.STRING_ARRAY.includes(filterObject.input_value_type) ?
				<input type="text" value={props.value} className={classname} name="action1" onChange={e=>props.filterOnChange(e, props.attr1, 'inputField', filterObject.has_multiple_input,props.attr5,props.attr6)} />
			: ShipConstants.NUMBER_ARRAY.includes(filterObject.input_value_type) ?
				<input type="text" 
					value={props.value} className={classname} 
					name="action1" 
					onKeyPress={numericValidationWithDot}
					onChange={e=>props.filterOnChange(e, props.attr1, 'inputField', filterObject.has_multiple_input,props.attr5,props.attr6)} />
			: null
		}
		</Wrp>
	);
}

export default textField;